document.addEventListener('DOMContentLoaded', () => {
  const variantSelect = document.querySelector('[data-product-variant]');
  const productPrice = document.querySelector('#ProductPrice');
  if (variantSelect && productPrice) {
    variantSelect.addEventListener('change', () => {
      const chosen = variantSelect.selectedOptions[0];
      if (chosen?.dataset.price) productPrice.textContent = chosen.dataset.price;
    });
  }
  document.querySelectorAll('[data-flash-event]').forEach((element) => {
    const status = element.querySelector('.event-status');
    const start = Date.parse(element.dataset.start || '');
    const end = Date.parse(element.dataset.end || '');
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
    const format = (time) => new Intl.DateTimeFormat('en-MY', {timeZone: 'Asia/Kuala_Lumpur', dateStyle: 'medium', timeStyle: 'short'}).format(time);
    const update = () => {
      const now = Date.now();
      if (now < start) status.textContent = 'Upcoming event · ' + format(start) + ' – ' + format(end) + ' MYT';
      else if (now >= end) status.textContent = 'This event has ended · ' + format(end) + ' MYT';
      else {
        const seconds = Math.floor((end - now) / 1000);
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor(seconds % 86400 / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        status.textContent = 'Event time remaining · ' + (days ? days + 'd ' : '') + hours + 'h ' + minutes + 'm · Ends ' + format(end) + ' MYT. Checkout eligibility is subject to the configured Shopify discount.';
      }
    };
    update();
    window.setInterval(update, 30000);
  });
});
